import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';
import { useWorkflowPanelStore } from '@/stores/workflow-panel-store';
import { cn } from '@/lib/utils';

interface AddNodesButtonProps {
  disabled?: boolean;
}

export const AddNodesButton: React.FC<AddNodesButtonProps> = ({
  disabled = false,
}) => {
  const isAddNodesOpen = useWorkflowPanelStore((state) => state.isAddNodesOpen);
  const openAddNodesPanel = useWorkflowPanelStore(
    (state) => state.openAddNodesPanel,
  );
  const closeAddNodesPanel = useWorkflowPanelStore(
    (state) => state.closeAddNodesPanel,
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size='icon'
          className='size-12 rounded-full shadow-lg [&_svg]:size-6'
          onClick={isAddNodesOpen ? closeAddNodesPanel : openAddNodesPanel}
          disabled={disabled}
          aria-label='Add Nodes'
          aria-pressed={isAddNodesOpen}
        >
          <Plus
            className={cn(
              'transition-transform',
              isAddNodesOpen && 'rotate-45',
            )}
          />
        </Button>
      </TooltipTrigger>
      <TooltipContent side='left'>
        <p>Add Nodes</p>
      </TooltipContent>
    </Tooltip>
  );
};
